import{range as r}from"remeda";var n=function(n,t,e){return r(0,1+(e-n)/t>>>0).map((function(r){return n+t*r}))};export{n as rangeStep};
//# sourceMappingURL=rangeStep.js.map
